<div class="page-loading" [class.page-loading_is-opaque]="isOpaque()">
  <div class="page-loading__overlay">
    <div class="page-loading__container">
      @if (title(); as title) {
        <div class="page-loading__title">
          {{ title }}
        </div>
      }
      <div class="page-loading__loading">
        <app-page-loading-indicator />
      </div>
    </div>
  </div>
</div>
